import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// Icons
import AssessmentIcon from "@material-ui/icons/Assessment";
import SchoolIcon from "@material-ui/icons/School";
import AssignmentIcon from "@material-ui/icons/Assignment";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import TimerIcon from "@material-ui/icons/Timer";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import LabelIcon from "@material-ui/icons/Label";

import { getHours, getMin } from "../../utils/time";

/* ---------------- STYLES ---------------- */

const useStyles = makeStyles(() => ({
  container: {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)", // ✅ 4 per row (desktop)
  gap: "16px",
  width: "100%",

  "@media (max-width: 1200px)": {
    gridTemplateColumns: "repeat(3, 1fr)", // ✅ 3 per row
  },

  "@media (max-width: 900px)": {
    gridTemplateColumns: "repeat(2, 1fr)", // ✅ 2 per row
  },

  "@media (max-width: 500px)": {
    gridTemplateColumns: "repeat(2, 1fr)", // ✅ FIX: 2 cards on mobile
    gap: "10px", // optional: tighter spacing for small screens
  },
},
  card: {
    borderRadius: "14px",
    padding: "16px 18px",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "110px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    transition: "all 0.2s ease",

    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 8px 22px rgba(0,0,0,0.15)",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  heading: {
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "0.3px",
    opacity: 0.95,
  },

  icon: {
    opacity: 0.9,
    display: "flex",
    alignItems: "center",
  },

  divider: {
    height: "1px",
    background: "rgba(255,255,255,0.25)",
    margin: "10px 0",
    borderRadius: "2px",
  },

  value: {
    fontSize: "26px",
    fontWeight: 800,
    lineHeight: 1.2,
    letterSpacing: "0.5px",
  },

  "@media (max-width: 600px)": {
  

    card: {
      padding: "12px",
      minHeight: "90px",
    },

    value: {
      fontSize: "20px",
    },

    heading: {
      fontSize: "11px",
    },
  },
}));

/* ---------------- DATA BUILDER (UNCHANGED) ---------------- */

export const getLabel = (
  stAg,
  clsAvg,
  testAttempt,
  testsAssign,
  attemptQuestions,
  questions,
  timeSpent,
  avgTime,
  concepts,
  chapters,
) => [
  {
    heading: "Student Avg. Score",
    value: stAg || "0",
    icon: AssessmentIcon,
  },
  {
    heading: "Class Avg. Score",
    value: clsAvg || "0",
    icon: SchoolIcon,
  },
  {
    heading: "Tests Assigned",
    value: `${testAttempt || "0"}/${testsAssign || "0"}`,
    icon: AssignmentIcon,
  },
  {
    heading: "Questions Attempted",
    value: `${attemptQuestions || "0"}/${questions || "0"}`,
    icon: HelpOutlineIcon,
  },
  {
    heading: "Avg. Time Spent on Test",
    value: getHours(
      parseFloat((timeSpent || 0) / (1000 * 60 * 60)).toFixed(2)
    ),
    icon: TimerIcon,
  },
  {
    heading: "Avg Time Spent On Question",
    value: getMin(
      parseFloat((avgTime || 0) / 1000).toFixed(2)
    ),
    icon: AccessTimeIcon,
  },
  {
    heading: "Chapters Covered",
    value: chapters || "0",
    icon: MenuBookIcon,
  },
  {
    heading: "Concept Covered in Test",
    value: concepts || "0",
    icon: LabelIcon,
  },
];

/* ---------------- SINGLE CARD ---------------- */

function MiniCard({ heading, value, Icon, bg }) {
  const classes = useStyles();

  return (
    <div className={classes.card} style={{ background: bg }}>
      <div className={classes.header}>
        <span className={classes.heading}>{heading}</span>
        <span className={classes.icon}>
          {Icon && <Icon fontSize="small" />}
        </span>
      </div>

      <div className={classes.divider} />

      <div className={classes.value}>{value}</div>
    </div>
  );
}

/* ---------------- WRAPPER ---------------- */

export default function MiniCards({ data = [] }) {
  const classes = useStyles();

  // 🎨 gradient palette (auto applied)
  const gradients = [
    "linear-gradient(135deg,#7c3aed, #a855f7)",
    "linear-gradient(135deg,#0284c7, #38bdf8)",
    "linear-gradient(135deg,#059669, #34d399)",
    "linear-gradient(135deg,#e11d48, #fb7185)",
    "linear-gradient(135deg,#f59e0b, #fbbf24)",
    "linear-gradient(135deg,#6366f1, #818cf8)",
    "linear-gradient(135deg,#14b8a6, #5eead4)",
    "linear-gradient(135deg,#ef4444, #f87171)",
  ];

  return (
    <div className={classes.container}>
      {data.map((item, index) => (
        <MiniCard
          key={index}
          heading={item.heading}
          value={item.value}
          Icon={item.icon}
          bg={gradients[index % gradients.length]}
        />
      ))}
    </div>
  );
}